import router from './router'
import store from './store/index'
import { getToken } from '@/utils/auth'
import server from './utils/server'

//判断权限是否存在
function hasPermission(roles, permissionRoles){
	if(roles.indexOf('admin')>=0) return true; //admin时直接通过
	if(!permissionRoles) return true; //
	return roles.some(role => permissionRoles.indexOf(role) >= 0);
}

//routerforEach()钩子函数
router.beforeEach((to, from, next)=>{
	window.document.title = to.name == undefined?'默认标题':to.name
	if(to.meta.noLogin){
		next();
		return false;
	}

	// if(true){
	if(getToken()){ //判断是否存在token getToken()
		if(to.path==='/login'){
			next({ path: '/' });
		}else{
			if(store.getters.roles.length === 0){ // 判断当前用户是否已拉取完user_info信息
				server.post("/User/GetCurrentUser").then(function(res){
					//next();
					var data = res.data.Data;
					var roles = data.PermissionList;
					store.dispatch('GenerateRoutes', { roles }).then(() => {
						router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
						   next({ ...to }) // hack方法 确保addRoutes已完成
					})

					// var userInfo = res.data.admin;
					if( !data.PermissionList || data.PermissionList.length==0 ){
						data.PermissionList = [];
						data.PermissionList.push("noPermission");
					}

					var userInfo = {
						...data,
						name: data.Name,
						role: data.PermissionList
					}
					store.dispatch('SetUserInfo', { userInfo }).then(()=>{
						console.log("设置用户信息成功...");
					})
			  }).catch(()=>{
				next({ path: "/login"});
			  })

			}else{
				//已拉取客户信息，直接下一步
				console.log(to)
				next();
			}
		}
	}else{
		next(`/login?redirect=${to.path}`)
	}
})
